import Vue from "vue";
import { IRepositionWatningModalProps } from '@/components/Globals/types/custom.t';

export default Vue.extend({
  name: "UGCRepositionWarningMixin",
  data() {
    return {
      contentProps: {} as IRepositionWatningModalProps,
      modalName: "" as string
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    }
  },
  methods: {
    continueRepositionFlow(componentToCustomize:any) {
      this.setImagesForRepositionFlow(componentToCustomize).then(() => {
        this.$store.commit(
          "ugc/tempData/SET_RECIPE",
          this.recipe_v2
        );
        this.$modal.hide(this.modalName);
        this.$modal.show(this.configuration.modals?.ugcSizeSelection ? "sizeSelectionModal" : "newSizeSelectionModal");
        // TODO if activeUGCIndex === 1 or at least 1 imageLibrary component in recipe v2
        this.$eventBus.$emit('start-reposition-image-library');
        this.$eventBus.$emit(
          "set-preselected-size",
          this.contentProps.sizeIdentifierValue
        );
        if (this.contentProps.deletePreviousRecipe) {
          this.$store.commit(
            "ugc/tempData/SET_RECIPE_FOR_DELETION",
            (this as any).$ugc.returnBucketSize(
              this.$store.state.ugc.tempData.features[this.$store.state.ugc.tempData.activeUGCIndex].activeUGCComponent
            )
          );
        }
      });
    },
    startRepositionFlow() {
      const componentToCustomize = (this as any).$ugc.getComponentsWithUgcApplied(false)[0];
      this.$eventBus.$emit("select-component", componentToCustomize);
      this.continueRepositionFlow(componentToCustomize);
    },
    setImagesForRepositionFlow(componentToCustomize:any) {
      return  new Promise<void>(resolve => {
        let { ugc: ugcObject } = this.recipe_v2.components[componentToCustomize];
        const { features, activeUGCIndex } = this.$store.state.ugc.tempData;
        const ugcRecipe = (features[activeUGCIndex].ugcFeature && activeUGCIndex !== 1)
          ? ugcObject.placements[0]
          : ugcObject.original_image;
        const fileFormat = ugcRecipe.image_url.split(".").pop();
        this.$store.commit("ugc/tempData/SET_UGC_IMAGE", {
          imagePath: ugcRecipe.image_url,
          temp_image_id: ugcRecipe.image_id,
          imageFormat: fileFormat
        });
        resolve();
      });
    },
    closeRepositionModal() {
      this.$modal.hide(this.modalName);
      this.$eventBus.$emit("show-buy-panel");
    },
    setSizesInModal(event: any) {
      this.modalName = !!this.$store.state.utils.configuration.modals?.ugcRepositionWarning ? "ugcRepositionWarningModal" : "NewRepositionWarningModal";
      this.contentProps = {...this.contentProps, ...event.params};
      this.$store.commit(
        "ugc/tempData/SET_STORE_MULTIPLE_UGC_SIZES",
        this.contentProps.storeMultipleUGCsizes
      );
    }
  }
});
